import Loader from "react-loader-spinner";
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${(props) =>
    props.overlay ? "rgba(0,0,0,.4)" : "rgba(0,0,0,0)"};
  margin: 0;
  padding: 0;
  padding-top: 12px;
  display: ${(props) => (props.loading ? "flex" : "none")};
  justify-content: center;
  ${(props) => props.center && "align-items: center;"}
`;

export default function Loading({ loading, type, ...rest }) {
  const loadingProp = loading ? 1 : undefined;
  const overlay = rest.overlay ? 1 : undefined;
  const center = rest.center ? 1 : undefined;
  return (
    <Container loading={loadingProp} overlay={overlay} center={center}>
      <Loader
        visible={loading}
        type={type || "Puff"}
        color="#00BFFF"
        height={100}
        width={100}
        {...rest}
      />
    </Container>
  );
}

export const loading = (
  <Loading
    loading={true}
    type="BallTriangle"
    color="#00BFFF"
    height={80}
    width={80}
    center
  />
);
export const DefaultLoading = (
  <Loading
    loading={true}
    type="BallTriangle"
    color="#fe8b01"
    height={80}
    width={80}
    center
  />
);
export const loadingAnimation = (
  <Loader
    visible={true}
    type={"Watch"}
    color="#fe8b01"
    height={100}
    width={100}
    className="my-4 flex justify-center"
  />
);
export const loadingAnimation2 = (
  <Loader
    visible={true}
    type={"Rings"}
    color="#fe8b01"
    height={100}
    width={100}
    className="my-4 flex justify-center"
  />
);
